import Response from "../../Data/Domain/Response";
import Commissions from "../Domain/Commissions";
import { getCommissions } from "./Commissions.service";

export async function getCommissionsRepository(params) {
  const data = await getCommissions(params);
  return new Response(data, Commissions).getSingle();
}
